export const NOTIFICATION_RETENTION_DAYS = 30;

export const notificationTypes = {
  surveySubmitted: {
    label: "Survey Submitted",
    //icon: "survey.svg",
    getMessage: (data) =>
      `${data.testerName} completed survey "${data.surveyName}" for ${data.projectName}`,
  },

  surveyReported: {
    label: "Survey Reported",
    //icon: "warning.svg",
    getMessage: (data) =>
      `${data.projectName} has a reported survey from ${data.testerName}`,
  },

  testerJoined: {
    label: "Tester Joined",
    icon: require("@/assets/notif_icon.png"),
    getMessage: (data) =>
      `${data.testerName} joined ${data.projectName}`,
  },
  adminMessage: {
    label: "Message from Admin",
    icon: require("@/assets/notif_icon.png"),
    getMessage: (data) =>
      `Admin (${data.projectName}): ${data.message}`,
  },
  announcement: {
    label: "Announcement",
    icon: require("@/assets/notif_icon.png"),
    getMessage: (data) => data.message,
  },
  surveyCreated: {
    label: "New Survey Published",
    icon: require("@/assets/notif_icon.png"),
    getMessage: (data) =>
      `A new survey "${data.surveyName}" was published for ${data.projectName}`,
  },
  //todo
  playSessionCreated: {
    label: "New Play Session",
    icon: require("@/assets/notif_icon.png"),
    getMessage: (data) =>
      `A new play session was created for "${data.projectName}"`
  },
//todo
  playSessionCompleted: {
    label: "Play Session Completed",
    icon: require("@/assets/notif_icon.png"),
    getMessage: (data) =>
      `${data.testerName} completed a play session for "${data.projectName}"`
  }
};






// WEBPACK FOOTER //
// ./src/util/notificationTypes.js